import React from 'react';
import './index.css';

interface GroupModalProps {
  newGroupName: string;
  setNewGroupName: (name: string) => void;
  setShowGroupModal: (show: boolean) => void;
  selectedDeliveries: string[];
  isCreatingGroup?: boolean;
  onCreateGroup: (groupName: string) => void;
}

const GroupModal: React.FC<GroupModalProps> = ({
  newGroupName,
  setNewGroupName,
  setShowGroupModal,
  selectedDeliveries,
  isCreatingGroup = false,
  onCreateGroup
}) => {
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && newGroupName.trim() && !isCreatingGroup) {
      onCreateGroup(newGroupName.trim());
    }
  };

  const handleCreate = () => {
    if (newGroupName.trim() && !isCreatingGroup) {
      onCreateGroup(newGroupName.trim());
    }
  };

  const handleClose = () => {
    setShowGroupModal(false);
    setNewGroupName('');
  };

  return (
    <div className="group-modal">
      <div className="group-modal__overlay">
        <div className="group-modal__content">
          <h3 className="group-modal__title">Create New Group</h3>
          <p className="group-modal__subtitle">
            Creating group with {selectedDeliveries.length} selected order(s)
          </p>
          <input
            type="text"
            placeholder="Enter group name (e.g., North Zone, Morning Batch)"
            value={newGroupName}
            onChange={(e) => setNewGroupName(e.target.value)}
            onKeyPress={handleKeyPress}
            className="group-modal__input"
            autoFocus
          />
          <div className="group-modal__actions">
            <button
              onClick={handleCreate}
              disabled={!newGroupName.trim() || isCreatingGroup}
              className={`group-modal__button group-modal__button--primary ${
                (!newGroupName.trim() || isCreatingGroup) ? 'group-modal__button--disabled' : ''
              }`}
            >
              {isCreatingGroup ? 'Creating...' : 'Create Group'}
            </button>
            <button
              onClick={handleClose}
              disabled={isCreatingGroup}
              className="group-modal__button group-modal__button--secondary"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupModal;